"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreEventLogger = void 0;
const firestore_1 = require("firebase/firestore");
class FirestoreEventLogger {
    constructor(logCollectionRef) {
        this.logCollectionRef = logCollectionRef;
    }
    add(payload) {
        (0, firestore_1.addDoc)(this.logCollectionRef, Object.assign(Object.assign({}, payload), { createdAt: Date.now(), updatedAt: Date.now() }));
    }
}
exports.FirestoreEventLogger = FirestoreEventLogger;
